var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAnz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "810px",
    height: "320px",
    viewBox: "-390 831.9 810 320",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 915.4122,
    cy: 287.1234,
    r: 266.5388,
    gradientTransform: "matrix(1.110652e-03 1.1107 0.8232 -8.347441e-04 14.3919 -155.9787)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#66C0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    style: {
      stopColor: "#4CAFD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6933,
    style: {
      stopColor: "#007DBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#004165"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M251.9,934.6c11.5,0,24.5,9.9,24.6,23.5c0,7.7-2.5,13.6-6.1,19c-2.4,3.5-4.2,7.5-4.9,10.4       c-0.8,3.3-2.5,11.1,7.2,11.3c6.3,0.1,21.8-5.3,34.4-20.4c9.6-12.1,15.4-27.4,15.4-44c0-39-31.6-70.6-70.6-70.6h0       c-39,0-70.6,31.6-70.6,70.6c0,16.7,5.7,32,15.4,44c12.5,15,28.1,20.5,34.4,20.4c9.7-0.2,8-8,7.2-11.3c-0.7-2.9-2.5-6.8-4.8-10.4       c-3.6-5.4-6.1-11.3-6.1-19C227.4,944.5,240.4,934.6,251.9,934.6L251.9,934.6z M376.7,1005.9c-2.9-2.4-8-5.9-18.4-7.4       c-14.4-2.2-27.3,1.2-35.1,4.3c-10.2,4-22.8,13.1-31.5,25c-9.1,12.5-13.9,31.5-9.4,51.2c1.3,5.6,2.7,8.7,4.7,12.6       c2.8,5.3,9.9,12.7,16.2,14c5,1,8.8-1.8,10.7-4c12.6-14.5,60.5-70.7,65.6-77.9C384.7,1016.6,381.4,1009.8,376.7,1005.9z       M180.6,1002.8c-7.8-3.1-20.7-6.5-35.1-4.3c-10.4,1.6-15.5,5.1-18.4,7.4c-4.7,3.9-8,10.7-2.9,17.8c5.2,7.2,53,63.4,65.6,77.9       c1.8,2.1,5.7,5,10.7,4c6.3-1.3,13.4-8.7,16.2-14c2-3.9,3.4-7,4.7-12.6c4.6-19.7-0.2-38.7-9.4-51.2       C203.4,1015.9,190.8,1006.8,180.6,1002.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-26.9,979.5l56.2,0c0,0-11.6,15.1-24.2,31.6h65.5c11.7-15.2,22.3-29.1,23.9-31.2         c7.4-9.6,9.1-18.3,9.1-25.9v-10.9c0-5.5-3.4-8.6-8.6-8.6l-121.8,0c-5,0-8.4,2.7-8.4,8.4v28.1C-35.3,976.7-32,979.5-26.9,979.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-388.7,1088.8c-1.5,2.6-1.5,5.3-0.6,7.1c1.1,2.1,3.5,3.2,6.1,3.2l39.9,0c5.1,0,9.5-2.7,12.1-6.7l44-69.8         h-59.7C-367.6,1055.2-388.3,1088-388.7,1088.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-224.8,1022.6h-55.8c1.4,7.7,11.7,65.3,12.3,68.7c0.9,5.2,4.2,7.8,9,7.8h38.4c3.5,0,5.3-1.1,6.9-3.1         c1.1-1.4,1.6-3.5,1.1-6.6L-224.8,1022.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-52.8,943c0-5.6-3.4-8.4-8.4-8.4h-34c-5,0-8.4,2.7-8.4,8.4l0,63.8l-32.2-57.4         c-6.4-10.6-17.2-14.5-29.8-14.8l-25.1,0c-5,0-8.4,2.7-8.4,8.4v68.2h42.1l6.4,11.4H-199v68.1c0,5.6,3.4,8.4,8.4,8.4h34         c5,0,8.4-2.7,8.4-8.4v-64.2l32.4,57.8c6.3,10.5,17.2,14.5,29.8,14.8h24.9c5,0,8.4-2.7,8.4-8.4v-68.1h-41.9l-6.4-11.4h48.3         L-52.8,943z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-239,942.5c-1-5.4-4.5-7.9-9.3-7.9H-265c-17.4,0-32.6,9.1-41.2,22.9c0,0-15.9,25.3-33.7,53.7h113.1         L-239,942.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M96.5,1054.2l-59,0c0,0,11.5-15,24.2-31.6H-3.8c-11.9,15.6-22.7,29.6-23.3,30.4         c-8.7,12.1-9.6,24.3-9.6,32.8c0,1.8,0,4.8,0,4.8c0,5.5,3.4,8.6,8.6,8.6H96.5c5,0,8.4-2.7,8.4-8.4v-28.1         C104.9,1056.9,101.5,1054.2,96.5,1054.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnz);
export default __webpack_public_path__ + "static/media/logo-anz.1e3a1eab82c629b5a5b44f8c18cbaf01.svg";
export { ForwardRef as ReactComponent };